<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtros por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Comprador"
              :roles="[]"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                     class="rounded-tag-small"
                                     show-details
                                     dense
                                     base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-select-enum
              dense
              label="Tipo de produto"
              :items="tiposProduto"
              class="rounded-tag-small"
              v-model="localTipoProduto"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { TipoProduto } from 'px-business-components';

export default {
  props: {},
  data: () => ({
    tiposProduto: TipoProduto.values,
    menuOpened: false,
    localEmpresa: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localTipoProduto: null,
  }),
  computed: {
    ...mapGetters('indicadoresFornecedor', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    empresa: {
      get() {
        return this.$store.getters['indicadoresFornecedor/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('indicadoresFornecedor/empresa', empresa);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['indicadoresFornecedor/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('indicadoresFornecedor/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['indicadoresFornecedor/produto'];
      },
      set(produto) {
        this.$store.dispatch('indicadoresFornecedor/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['indicadoresFornecedor/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('indicadoresFornecedor/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['indicadoresFornecedor/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('indicadoresFornecedor/responsavel', responsavel);
      },
    },
    tipoProduto: {
      get() {
        return this.$store.getters['indicadoresFornecedor/tipoProduto'];
      },
      set(tipoProduto) {
        this.$store.dispatch('indicadoresFornecedor/tipoProduto', tipoProduto);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.tipoProduto = this.localTipoProduto;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localTipoProduto = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localTipoProduto = this.tipoProduto || null;
  },
};
</script>
